import axios from "axios";
import { handleError, requestInterceptor, responseInterceptor } from "./interceptor";

const service = axios.create({
  timeout: 0,
  baseURL: process.env.NODE_ENV == 'development' ? '/' :process.env.VUE_APP_BASE_API,
  headers: {
    ...(process.env.NODE_ENV == 'development' ? {app: 'yl_mall'} : {})
  }
});
console.log(process.env.NODE_ENV)

service.interceptors.request.use(requestInterceptor, handleError);

service.interceptors.response.use(responseInterceptor, handleError);

export default service;
